// Product identity from F5's finished artwork (BRAND_ASSETS); files only, never redrawn.
import { APP_NAME, BRAND_ASSETS } from '../config/brand.ts';
import { Link } from '../lib/router.tsx';

type Asset = (typeof BRAND_ASSETS)[keyof typeof BRAND_ASSETS];

/**
 * One artwork in the app's own theme: the ink file in Day, the reverse file in Night, and System
 * following the OS. The hidden variant is `display:none`, so assistive technology hears one name.
 */
export function BrandImage({ asset, height, className }: { asset: Asset; height: number; className?: string }) {
  const width = Math.round((asset.width / asset.height) * height * 100) / 100;
  return (
    <span className={`brand-image${className ? ` ${className}` : ''}`}>
      <img className="theme-day" src={asset.day} alt={APP_NAME} width={width} height={height} decoding="async" />
      <img className="theme-night" src={asset.night} alt={APP_NAME} width={width} height={height} decoding="async" />
    </span>
  );
}

/**
 * Rail identity: the 32 px mark on the 80 px rail and the compact lockup (24 px tall) in the
 * 216 px rail, as a link home named "Sidetone". The top bar shows the lockup at narrower widths.
 */
export function Wordmark() {
  return (
    <Link to="/inbox/calls" className="wordmark" title={APP_NAME}>
      <BrandImage asset={BRAND_ASSETS.mark32} height={32} className="wordmark-mark" />
      <BrandImage asset={BRAND_ASSETS.lockupCompact} height={24} className="wordmark-full" />
    </Link>
  );
}
